<template>
    <div v-if="modelValue" class="modal" @click.self="closeModal">
      <div class="modal-content" @click.stop>
        <span class="close" @click="closeModal">&times;</span>
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent } from "vue"
  
  export default defineComponent({
    name: "ModalComponent",
    props: {
      modelValue: Boolean
    },
    setup(props, {emit}) {
      const closeModal = () => {
        emit('update:modelValue', false);
      };

      return {
        closeModal
      }
    }
  });
  </script>
  
  <style>
  .modal {
    position: fixed;
    z-index: 2;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.0);
  }
  
  .modal-content {
    background-color: rgb(36, 36, 36);
    color: ghostwhite;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 60%;
  }
  
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
  }
  
  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
</style>
